// Chrome Extension Constants
export const CHROME_EXTENSION = {
  ID: process.env.NEXT_PUBLIC_EXTENSION_ID || 'hihhifjnmddhenncjpfgikhdhmjbhleh',
  VERSION: '1.0.1',
  PUBLISHER: 'Mira Network',
  STORE_URL: 'https://chromewebstore.google.com/detail/fact-verifier/hihhifjnmddhenncjpfgikhdhmjbhleh',
  NAME: 'Fact Verifier',
  TIMEOUTS: {
    STATUS_CHECK: 1000, // 1 second
    TOKEN_SHARE: 5000,  // 5 seconds
  }
} as const;